// extracted by mini-css-extract-plugin
export default {"nav_container":"Nav_nav_container__lWBnt","nav_title_wrapper":"Nav_nav_title_wrapper__NIjJN","logo":"Nav_logo__0YvBH","nav_details":"Nav_nav_details__LenBS","nav":"Nav_nav__HrYpV"};